//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { getCurrentUser } from 'aws-amplify/auth';
//  -- Components ---------------------
import InitialLoading from 'components/InitialLoading';
//  -- Features -----------------------
import EbookLayout from 'features/EbookLayout';
import queryString from 'query-string';
import React, { useEffect, useMemo, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
//  -- Thunks -------------------------
import { handleListClassActivities, handleListClassActivitiesForStudent } from 'store/classActivities/thunks';
import { handleListClassQuizzes, handleListClassQuizzesForStudent } from 'store/classQuizzes/thunks';
import { handleListUserSubmissionsByClass } from 'store/submissions/thunks';
import { handleListClassUsers } from 'store/userClasses/thunks';
import { useCurrentOrgPermission } from 'store/organizations/selectors';
import { useAlertView } from "store/alert/selectors";
import styled from 'styled-components';
//  -- Lib ----------------------------
import { ebookConfigDinamic } from 'utils/lib/ebookHelper';
import { handleListInstructionByUser, handleListInstructionByClass } from "store/instructions/thunks"
import { find, get, has, filter } from 'lodash';
import { useAnswerView, useMainbookView, usePDFView, useSentenceView, useStoryView } from "store/main_book_popup/selectors";
import { useExams } from "store/exams/selectors";
import { useSchoologyGradeCategory } from 'store/schoologyauth/selectors';
import { usePageTranslations } from "store/page_translations/selectors";
import { useFetchAllContent } from "components/hooks";
import { handleGetAllSlides } from "store/slides/thunk";
import { handleListChapterArticle, handleListStoryAiConfig } from "store/StoryAiCofig/thunks";
import { handleListGrammarContent, handleListVocabContent } from "store/page_translations/thunks";
import { handleListGameByBook } from "store/one_game/thunks";
import { useAllDistrictTeacher } from 'store/users/selectors';
import { handleGetDistrictTeacher } from 'store/users/thunks';
import { handleLearningModuleCount } from 'store/bingo/thunks';
import SentryWrap from 'components/Sentry';
import { redirectToHome } from 'utils/config/navigation';


//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const CenterContainer = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    min-height: 90vh;
    justify-content: center;
    width: 100%;
`;

export const Wrapper = styled.div`
    height: 100%;
    width: 100%;
`;



const EbookContainer = ({
    currentClass,
    currentUser,
    classUsers,
    tipsBook,
    classActivities,
    classQuizzes,
    submissions,
    booksAllList
}) => {
    const location = useLocation();
  	const navigate = useNavigate();
    const dispatch = useDispatch();
    const allDistrictTeacher = useAllDistrictTeacher();
    const search = queryString.parse(location.search);
    const [ebookFlag, setEbookFlag] = useState(null);
    const [ebookFlagTeacherEdition, setEbookFlagTeacherEdition] = useState(null);
    const [loading, setLoading] = useState(true);
    const [mounted, setMounted] = useState(false);
    const book = find(booksAllList, { id: search.chapter });
    const lessonPlan = book?.lessonPlan;
    const SuperLesson = book?.superLesson;
    const DifferentiationLesson = book?.differentiationLesson;
    const sentenceStarterData = book?.sentence_starter_data;
    const rubrics = get(book, "rubrics", []);
    const assignmentPlan = book?.assignmentPlan;
    const ai_content = get(book,"ai_content",[]);
    const workbook_plan = book?.workbook_plan;
    const main_book = book?.main_book;
    const [, invokeAlert, revokeALert] = useAlertView()
    const orgPermissions = useCurrentOrgPermission()
    const exams = useExams();
    const { revokeAnswerView } = useAnswerView();
    const { revokeSentenceView } = useSentenceView()
    const { revokeMainbookView } = useMainbookView()
    const { revokePDFView } = usePDFView()
    const { revokeStoryView } = useStoryView();
    const data = ebookConfigDinamic(search.chapter, booksAllList);
    const examBookIds = useMemo(()=>exams?exams.flatMap(entry => entry.exams.map(exam => `${exam.bookId}`)):[],[exams]);
    const dataBook = useMemo(()=>find(booksAllList, x => x.id == search.chapter),[location.search]);
    const path_page = Number(search.page) || 1;
    const existTeacherEdition = filter(get(dataBook, "teacherEdition"), x => Number(x.pageId) == path_page).length > 0;
    const existShowAnswer = filter(get(dataBook, "pagesTeacher"), x => Number(x.pageId) == path_page).length > 0;
    const bookPages = get(dataBook, "pages", []);
    const fetchPageExist = dataBook
        ? filter(bookPages, (x) => Number(x.pageId) == path_page).length > 0
        : null;
    const existAssignmentLink = filter(get(dataBook, "assignment_book_link_plan"), x => x.page == path_page);
    const getPageExist = path_page;
    const [,,,listAllclassSchoologyGradeCategory] = useSchoologyGradeCategory()
    const { handleFetchPageTranslations } = usePageTranslations()
    const {fetchAllContent} = useFetchAllContent();

    useEffect(() => {
        setTimeout(() => setMounted(true), 250)
        return () => {
            revokeAnswerView();
            revokeSentenceView();
            revokeMainbookView();
            revokePDFView();
            revokeStoryView();
        }
    }, []);
    useEffect(() => {
        if (orgPermissions && typeof orgPermissions['exams'] === "boolean") {
            // const assignmentBooks = ['31', '35', '36', '45', '50', '51']
            if (examBookIds.includes(search.chapter)) {
                if (!orgPermissions['exams']) {
                    invokeAlert()
                    setTimeout(() => {
                        navigate(redirectToHome(currentUser) || '-1');
                        revokeALert()
                    }, 5000)
                }
            }
        }
        if (orgPermissions) {
            const getBookArr = orgPermissions['books'];
            const filterBookId = find(getBookArr, (obj) => obj.bookId == search.chapter)
            if (filterBookId&&filterBookId?.available === false) {
                invokeAlert()
                setTimeout(() => {
                    navigate(redirectToHome(currentUser) || '-1');
                    revokeALert()
                }, 5000)
            }
        }
    }, [orgPermissions])
    useEffect(() => {
        async function fetchData() {
            try {
                await getCurrentUser();
            } catch {
                navigate('/');
            }
        }
        fetchData();
    }, []);

    const listInstruction = async () => {
        if (has(currentUser, "id") && currentUser.role == "teacher") {
            await dispatch(handleListInstructionByUser(currentUser.id))
        }
        if (has(currentClass, "id") && currentUser.role != "teacher") {
            dispatch(handleListInstructionByClass(get(currentClass, "id")));
        }
    }
    const getStudentSubmissions = async () => {
        if (get(currentUser, "role") == "student") {
            // return dispatch(handleListUserSubmissions(currentUser?.id))
            return  dispatch(handleListUserSubmissionsByClass(currentUser?.id,currentClass?.id))
        }
    }
    const getBookDataForTeacher = async () => {
        if (get(currentUser, "role") === 'teacher' && has(currentClass, "id")) {
            dispatch(handleListClassUsers(get(currentClass, "id")));
        }
    }
    const listClassAssignments = async () => {
        if (has(currentClass, "id") && get(currentUser, "role") != "student") {
            dispatch(handleListClassActivities(currentClass.id));
            dispatch(handleListClassQuizzes(currentClass.id));
        } else {
            dispatch(handleListClassActivitiesForStudent(get(currentClass, "id"), get(currentUser, "id")));
            dispatch(handleListClassQuizzesForStudent(get(currentClass, "id"), get(currentUser, "id")));
        }
    }

    const fetchDistrictData = async () => {
      try {
        if (currentUser?.orgId && currentUser?.id && currentUser?.role === 'teacher' && allDistrictTeacher.length === 0) {
          dispatch(handleGetDistrictTeacher(currentUser?.orgId, currentUser?.id));
        }
      } catch (error) {
        console.log(error, 123);
      }
    };

    const fetchLearningModuleCount = async () => {
        if (currentUser?.role === 'student' || currentUser?.role === 'teacher') {
          dispatch(handleLearningModuleCount({
            chapter: search.chapter,
            userId: currentUser?.role === 'student' ? currentClass?.teacherId : currentUser.id,
            pageId: path_page,
          }));
        }
    };

    const lazyFetchData = async () => {
      await Promise.allSettled([
        fetchDistrictData(),
        dispatch(handleListGrammarContent(search.chapter)),
        dispatch(handleListVocabContent(search.chapter)),
        listInstruction()
      ])
    }

    useEffect(() => {
        if (fetchPageExist !== false) return;
        navigate(-1);
    }, [fetchPageExist, navigate]);

    useEffect(() => {
        if (!search.chapter || !Array.isArray(booksAllList) || booksAllList.length === 0) {
            return;
        }
        const found = find(booksAllList, (x) => String(x.id) === String(search.chapter));
        if (found) return;
        navigate(redirectToHome(currentUser) || '-1');
    }, [booksAllList, search.chapter, currentUser, navigate]);

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            const is_student = currentUser?.role === "student";
            const user_id = currentUser?.id;
            const class_id = currentClass?.id;
            await Promise.allSettled([
                handleFetchPageTranslations(search.chapter),
                getStudentSubmissions(),
                getBookDataForTeacher(),
                listClassAssignments(),
                // listInstruction(),
                // fetchDistrictData(),
                fetchAllContent(search.chapter,getPageExist),
                dispatch(handleGetAllSlides(search.chapter)),
                dispatch(handleListStoryAiConfig({chapter : search.chapter, user_id, class_id },is_student)),
                // dispatch(handleListGrammarContent(search.chapter)),
                // dispatch(handleListVocabContent(search.chapter)),
                dispatch(handleListChapterArticle({chapter : search.chapter })),
                // dispatch(handleListOneGameGallery()),
                // dispatch(handleListOneGameCategory("pictures_categories")),
                dispatch(handleListGameByBook(user_id, search.chapter, "my_study", path_page)),
                fetchLearningModuleCount()
            ])
            setLoading(false)
            lazyFetchData()

        }
        fetchData();
    }, [
        currentUser, search?.chapter, currentClass, dispatch
    ])
    useEffect(()=>{
        listAllclassSchoologyGradeCategory()
    },[])
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const getIsOnlYTeacher = () => {
        return book ? book?.onlyTeacher : false;
    };

    useEffect(()=>{
        const hiddenBook = get(currentClass,"hide_books",[]).map(data => data?.bookId); 
        const is_student = currentUser.role == "student"
        const is_hiddentfor_student = hiddenBook.includes(search.chapter) && is_student;
        const is_only_teacher_student = getIsOnlYTeacher() && is_student;
        if(is_hiddentfor_student||is_only_teacher_student){
            navigate(redirectToHome(currentUser) || '-1');
            return;
        }
    },[booksAllList,currentUser])

    return (
    <SentryWrap>
        <Wrapper>
            {loading ? (
                <CenterContainer>
                    <InitialLoading mounted={mounted} />
                </CenterContainer>
            ) : (
                <EbookLayout
                    classUsers={classUsers}
                    activity={search.activity}
                    chapter={search.chapter}
                    data={data}
                    tips={tipsBook}
                    existTeacherEdition={existTeacherEdition}
                    existShowAnswer={existShowAnswer}
                    existAssignmentLink={existAssignmentLink}
                    ebookFlag={ebookFlag}
                    setEbookFlag={setEbookFlag}
                    ebookFlagTeacherEdition={ebookFlagTeacherEdition}
                    setEbookFlagTeacherEdition={setEbookFlagTeacherEdition}
                    history={navigate}
                    page={getPageExist}
                    quiz={search.quiz}
                    currentUser={currentUser}
                    submissions={submissions}
                    classQuizzes={classQuizzes}
                    classActivities={classActivities}
                    lessonPlan={lessonPlan}
                    SuperLesson={SuperLesson}
                    DifferentiationLesson={DifferentiationLesson}
                    sentenceStarterData={sentenceStarterData}
                    rubrics={rubrics}
                    assignmentPlan={assignmentPlan}
                    ai_content={ai_content}
                    workbook_plan={workbook_plan}
                    main_book={main_book}
                    booksAllList={booksAllList}
                    currentClass={currentClass}
                    book={book}
                    dataBook={dataBook}
                />
            )}
        </Wrapper>
    </SentryWrap>
    );
};


const mapStateToProps = state => ({
    currentClass: state.currentClass,
    currentUser: state.currentUser,
    classUsers: state.classUsers,
    tipsBook: state.tipsBook,
    classActivities: state.classActivities,
    classQuizzes: state.classQuizzes,
    submissions: state.submissions,
    booksAllList: state.booksAllList,
});

export default connect(mapStateToProps, null)(EbookContainer);
